import { IBorderRadii } from '../../../shared/contexts/styleContext';

export const BorderRadius: IBorderRadii = {
    small: '4px',
    medium: '8px',
    large: '16px',
    circle: '50%',
    none: '0'
};
